import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AffiliateProgramService } from '@/services/affiliate-program.service';
import { toast } from '@/hooks/use-toast';
import { useTranslation } from 'react-i18next';

export const useAcceptInvite = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('affiliates');

  return useMutation({
    mutationFn: (productInvitationId: string) =>
      AffiliateProgramService.acceptInvite(productInvitationId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['affiliates'] });
      toast({
        variant: 'success',
        description: t('invite_accepted_success'),
      });
    },
    onError: () => {
      toast({
        variant: 'error',
        description: t('invite_accepted_error'),
      });
    },
  });
};

export const useDenyInvite = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('affiliates');

  return useMutation({
    mutationFn: (productInvitationId: string) =>
      AffiliateProgramService.denyInvite(productInvitationId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['affiliates'] });
      toast({
        variant: 'success',
        description: t('invite_denied_success'),
      });
    },
    onError: () => {
      toast({
        variant: 'error',
        description: t('invite_denied_error'),
      });
    },
  });
};